export default __webpack_public_path__ + "static/media/endangered.1a664f6f.png";